export const createGameVoteSlice = ({ initialVoteState, onVoteAccept, onVoteReject })=>(set, get)=>({
            gameVote: {
                voteState: initialVoteState,
                dismissedVoteId: undefined,
                setVoteState: (voteState)=>{
                    const gameVote = get().gameVote;
                    const isDismissedVote = voteState != undefined && voteState.id == gameVote.dismissedVoteId;
                    const shouldClearVoteState = voteState == undefined || isDismissedVote;
                    if (shouldClearVoteState) {
                        set({
                            gameVote: {
                                ...gameVote,
                                voteState: undefined
                            }
                        });
                        return;
                    }
                    set({
                        gameVote: {
                            ...gameVote,
                            voteState: voteState,
                            dismissedVoteId: undefined
                        }
                    });
                },
                dismissVote: (voteId)=>{
                    set({
                        gameVote: {
                            ...get().gameVote,
                            voteState: undefined,
                            dismissedVoteId: voteId
                        }
                    });
                },
                onVoteAccept: onVoteAccept,
                onVoteReject: onVoteReject
            }
        });
